module.exports = __webpack_public_path__ + "img/building.92ee57c6.png";